// src/Login.js
import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {signInWithEmailAndPassword} from "firebase/auth";
import {auth} from "../firebase";
import {Button} from "react-bootstrap";

function AdminLogin({onLogin}) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      onLogin(userCredential.user);
      //console.log("로그인 성공 :", userCredential.user); //TODO del
      navigate("/payment");
    } catch (err) {
      //console.log("로그인 에러 :", err);
      setError("로그인 실패!");
    }
  };

  return (
    <section className="position-relative overflow-hidden pt-5 pt-lg-3">
      <div style={{textAlign: "center"}}>
        <h1 className="text-center">개인 학습자 로그인</h1>

        <div className="tab-content" id="course-pills-tabContent">
          <form
            onSubmit={handleSubmit}
            style={{
              display: "flex",
              flexDirection: "column",
              width: "400px",
              gap: "15px",
            }}
          >

            {error && (
              <p style={{color: "red", textAlign: "center", marginBottom: "10px"}}>
                {error}
              </p>
            )}

            <div style={{display: "flex", flexDirection: "column"}}>
              <label htmlFor="email" style={{marginBottom: "5px", fontWeight: "bold"}}>
                Email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{padding: "10px", fontSize: "16px"}}
              />
            </div>

            <div style={{display: "flex", flexDirection: "column"}}>
              <label htmlFor="password" style={{marginBottom: "5px", fontWeight: "bold"}}>
                Password
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{padding: "10px", fontSize: "16px"}}
              />
            </div>

            <Button
              type="submit"
              variant="primary"
              size="lg"
              className="card-img-top mt-3"
            >
              로그인
            </Button>
          </form>
        </div>
      </div>
    </section>

  );
}

export default AdminLogin;
